import { ControllerRenderProps } from 'react-hook-form'
import { Textarea } from '@/components/ui/textarea'
import { MarkdownEditor } from './MarkdownEditor'

interface RichTextFieldProps {
  field: ControllerRenderProps<any, any>
  format: 'plain' | 'markdown'
  rows?: number
  placeholder?: string
}

export function RichTextField({
  field,
  format,
  rows = 6,
  placeholder,
}: RichTextFieldProps) {
  const stringValue = typeof field.value === 'string' ? field.value : ''

  if (format === 'markdown') {
    return (
      <MarkdownEditor
        value={stringValue}
        onChange={field.onChange}
        onBlur={field.onBlur}
        placeholder={placeholder}
      />
    )
  }

  return (
    <div>
      <Textarea
        placeholder={placeholder}
        rows={rows}
        className="resize-vertical min-h-[120px] font-mono text-sm"
        name={field.name}
        value={stringValue}
        onChange={field.onChange}
        onBlur={field.onBlur}
        ref={field.ref}
      />
    </div>
  )
}
